<template>
    <div class="container">
        <b-modal
            :model-value="showDialogEditNiif"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="lg"
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog edit-niif-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.niif }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            :value="Item?.niif"
                            type="text"
                            class="form-input"
                            disabled
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.description }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="descripcionLocal"
                            type="text"
                            class="form-input"
                            :disabled="showReclasifica"
                            placeholder="Descripción del NIIF"
                            @input="onChange"
                        />
                    </b-col>
                </b-row>

                <b-row v-if="showReclasifica" class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.reclasificar }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="niifNuevoLocal"
                            type="text"
                            class="form-input"
                            placeholder="Nuevo NIIF"
                            @input="onChange"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row" v-if="!showReclasifica">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.levelFirst }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="selectedPrimerNivel"
                            class="form-input"
                            @change="onChange"
                        >
                            <b-form-select-option :value="null">
                                -- {{ labels.select }} --
                            </b-form-select-option>
                            <b-form-select-option 
                                v-for="firstLev in localListFirstLevel" 
                                :key="firstLev.id" 
                                :value="String(firstLev.primer_nivel)"
                            >
                                {{ firstLev?.descripcion }}
                            </b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row" v-if="!showReclasifica">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.levelSecond }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-select
                            v-model="selectedSegundoNivel"
                            class="form-input"
                            @change="onChange"
                        >
                            <b-form-select-option :value="null">
                                -- {{ labels.select }} --
                            </b-form-select-option>
                            <b-form-select-option 
                                v-for="secondLev in localListSecondLevelFirst" 
                                :key="secondLev.id" 
                                :value="String(secondLev.segundo_nivel)"
                            >
                                {{ secondLev?.descripcion }}
                            </b-form-select-option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button 
                        v-if="!showReclasifica" 
                        class="reset-btn-secondary mr-2" 
                        @click="reclasificarNiif"
                    >
                        {{ labels.breclasificar }}
                    </b-button>
                    <b-button class="reset-btn-secondary" @click="closeDialog">{{ labels.close }}</b-button>
                    <b-button 
                        class="reset-btn-primary ml-2" 
                        @click="confirmSave" 
                        :disabled="!hasUnsavedChanges || isLoading"
                    >
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <!-- Modal de Confirmación -->
        <b-modal
            :model-value="showConfirmModal"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="md"
            :title="confirmLabels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog confirm-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ confirmLabels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ confirmLabels.infoText }}</div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeConfirmModal">
                        {{ confirmLabels.cancel }}
                    </b-button>
                    <b-button class="reset-btn-primary ml-2" @click="executeAction">
                        {{ confirmLabels.confirm }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import PlanConsolidacion from "../../services/PlanConsolidacion"
import PrimerNivel from "../../services/PrimerNivel"
import SegundoNivel from "../../services/SegundoNivel"

export default {
    name: "EditaNiif",
    props: {
        Item: {
            type: Object,
            default: () => ({})
        },
        showDialogEditNiif: {
            type: Boolean,
            default: false
        },
        listFirstLevel: {
            type: Array,
            default: () => []
        },
        listSecondLevelFirst: {
            type: Array,
            default: () => []
        },
        listNiif: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        showReclasifica: false,
        originalItem: null,
        isLoading: false,
        selectedPrimerNivel: null,
        selectedSegundoNivel: null,
        descripcionLocal: "",
        niifNuevoLocal: "",
        localListFirstLevel: [],
        localListSecondLevelFirst: [],
        localListSecondLevel: [],
        showConfirmModal: false,
        pendingAction: null,
        pendingClose: false
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Modificación NIIF",
                    niif: "NIIF",
                    select: "Seleccione...",
                    levelFirst: "Primer Nivel",
                    levelSecond: "Segundo Nivel",
                    save: "Guardar",
                    breclasificar: "Reclasificar",
                    reclasificar: "NIIF Nuevo",
                    close: "Cerrar",
                    description: "Descripción",
                    infoTitle: "Datos del NIIF",
                    infoText: "Actualiza la información del NIIF y guarda los cambios."
                }
            } else {
                return {
                    title: "NIIF Update",
                    niif: "NIIF",
                    select: "Select...",
                    levelFirst: "First Level",
                    levelSecond: "Second Level",
                    save: "Save",
                    breclasificar: "Reclassify",
                    reclasificar: "New NIIF",
                    close: "Close",
                    description: "Description",
                    infoTitle: "NIIF information",
                    infoText: "Update the NIIF information and save changes."
                }
            }
        },
        confirmLabels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Confirmar acción",
                    infoTitle: "¿Está seguro?",
                    infoText: "¿Está seguro que desea realizar esta acción?",
                    confirm: "Confirmar",
                    cancel: "Cancelar"
                }
            } else {
                return {
                    title: "Confirm action",
                    infoTitle: "Are you sure?",
                    infoText: "Are you sure you want to perform this action?",
                    confirm: "Confirm",
                    cancel: "Cancel"
                }
            }
        },
        hasUnsavedChanges() {
            if (!this.originalItem || this.isLoading) return false

            if (this.showReclasifica) {
                const currentNiifNuevo = this.niifNuevoLocal || this.Item.niif_nuevo
                const originalNiifNuevo = this.originalItem.niif_nuevo || this.originalItem.niif
                return String(currentNiifNuevo) !== String(originalNiifNuevo)
            }

            const currentItem = {
                descripcion: this.descripcionLocal || this.Item.descripcion,
                primer_nivel: this.selectedPrimerNivel,
                segundo_nivel: this.selectedSegundoNivel
            }

            const originalItem = {
                descripcion: this.originalItem.descripcion,
                primer_nivel: this.originalItem.primer_nivel !== undefined && this.originalItem.primer_nivel !== null 
                    ? String(this.originalItem.primer_nivel) 
                    : null,
                segundo_nivel: this.originalItem.segundo_nivel !== undefined && this.originalItem.segundo_nivel !== null 
                    ? String(this.originalItem.segundo_nivel) 
                    : null
            }

            return JSON.stringify(currentItem) !== JSON.stringify(originalItem)
        }
    },
    watch: {
        showDialogEditNiif: {
            handler(newVal) {
                if (newVal && this.Item && Object.keys(this.Item).length > 0) {
                    this.originalItem = { ...this.Item }
                    this.isLoading = false
                    this.showReclasifica = false
                    this.descripcionLocal = this.Item.descripcion || this.Item.nameNiif || ""
                    this.niifNuevoLocal = this.Item.niif_nuevo || this.Item.niif || ""
                    this.pendingAction = null
                    this.pendingClose = false
                    this.cargarDatosIniciales()
                }
            },
            immediate: true
        },
        selectedPrimerNivel: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal && this.showDialogEditNiif) {
                    this.selectedSegundoNivel = null
                    this.filtrarSegundoNivel()
                    this.onChange()
                }
            }
        }
    },
    methods: {
        cargarDatosIniciales() {
            const codReporte = this.Item.codReporte
            if (!codReporte) {
                this.$toast.error("No se pudo obtener el código del reporte")
                return
            }

            this.isLoading = true

            Promise.all([
                PrimerNivel.getFirstLevelByReporte(codReporte),
                SegundoNivel.getAllLevelSecond(codReporte)
            ])
            .then(([primerNivelRes, segundoNivelRes]) => {
                this.localListFirstLevel = primerNivelRes.data.firstLevByReport || []
                this.localListSecondLevel = segundoNivelRes.data.segundoNivel || []

                const primerNivelValue = this.Item.primer_nivel !== undefined && this.Item.primer_nivel !== null 
                    ? String(this.Item.primer_nivel) 
                    : null
                this.selectedPrimerNivel = primerNivelValue

                this.filtrarSegundoNivel()

                this.$nextTick(() => {
                    const segundoNivelValue = this.Item.segundo_nivel !== undefined && this.Item.segundo_nivel !== null 
                        ? String(this.Item.segundo_nivel) 
                        : null
                    
                    const existsInList = this.localListSecondLevelFirst.some(
                        item => String(item.segundo_nivel) === segundoNivelValue
                    )
                    
                    if (existsInList) {
                        this.selectedSegundoNivel = segundoNivelValue
                    } else {
                        this.selectedSegundoNivel = null
                    }
                })
            })
            .catch((err) => {
                console.error(err)
                this.$toast.error("Error al cargar los niveles")
            })
            .finally(() => {
                this.isLoading = false
            })
        },
        filtrarSegundoNivel() {
            if (this.selectedPrimerNivel && this.selectedPrimerNivel !== 'null' && this.localListSecondLevel.length > 0) {
                this.localListSecondLevelFirst = this.localListSecondLevel.filter((d_second) => {
                    return String(d_second.primer_nivel) === String(this.selectedPrimerNivel)
                })
            } else {
                this.localListSecondLevelFirst = []
            }
        },
        onChange() {
            // Este método se ejecuta cuando hay cambios
        },
        closeDialog() {
            if (this.hasUnsavedChanges) {
                this.pendingAction = 'close'
                this.pendingClose = true
                this.showConfirmModal = true
            } else {
                this.clicked()
            }
        },
        confirmSave() {
            if (this.showReclasifica && !this.niifNuevoLocal) {
                this.$toast.error("Diligenciar el campo Nuevo NIIF")
                return
            }
            if (!this.showReclasifica && !this.descripcionLocal) {
                this.$toast.error("Diligenciar el campo Descripción")
                return
            }
            this.pendingAction = 'save'
            this.pendingClose = false
            this.showConfirmModal = true
        },
        closeConfirmModal() {
            this.showConfirmModal = false
            this.pendingAction = null
            this.pendingClose = false
        },
        executeAction() {
            this.showConfirmModal = false
            const action = this.pendingAction
            this.pendingAction = null

            if (action === 'save') {
                this.editarNiif()
            } else if (action === 'close') {
                this.restoreOriginalValues()
                this.clicked()
            }
        },
        clicked() {
            this.showReclasifica = false
            this.selectedPrimerNivel = null
            this.selectedSegundoNivel = null
            this.localListFirstLevel = []
            this.localListSecondLevelFirst = []
            this.localListSecondLevel = []
            this.descripcionLocal = ""
            this.niifNuevoLocal = ""
            this.pendingAction = null
            this.pendingClose = false
            this.$emit('clicked', false)
        },
        reload() {
            this.$emit('reload')
        },
        restoreOriginalValues() {
            if (this.originalItem) {
                Object.assign(this.Item, this.originalItem)
                this.descripcionLocal = this.originalItem.descripcion || this.originalItem.nameNiif || ""
                this.niifNuevoLocal = this.originalItem.niif_nuevo || this.originalItem.niif || ""
                this.selectedPrimerNivel = this.originalItem.primer_nivel !== undefined && this.originalItem.primer_nivel !== null 
                    ? String(this.originalItem.primer_nivel) 
                    : null
                this.filtrarSegundoNivel()
                this.$nextTick(() => {
                    const segundoNivelValue = this.originalItem.segundo_nivel !== undefined && this.originalItem.segundo_nivel !== null 
                        ? String(this.originalItem.segundo_nivel) 
                        : null
                    const existsInList = this.localListSecondLevelFirst.some(
                        item => String(item.segundo_nivel) === segundoNivelValue
                    )
                    if (existsInList) {
                        this.selectedSegundoNivel = segundoNivelValue
                    } else {
                        this.selectedSegundoNivel = null
                    }
                })
            }
        },
        editarNiif() {
            if (this.showReclasifica) {
                const niifNuevo = this.niifNuevoLocal || this.Item.niif_nuevo
                if (!niifNuevo || niifNuevo == "") {
                    this.$toast.error("Nuevo NIIF no puede estar vacío")
                    return
                }
                const nuevoNiif = this.listNiif.find((r_niif) =>
                    String(r_niif.niif) == String(niifNuevo)
                )
                if (nuevoNiif) {
                    this.$toast.error("NIIF ya existe.(" + nuevoNiif.niif + ")")
                    this.niifNuevoLocal = this.Item.niif
                    return
                }

                this.isLoading = true
                let form = {
                    'codReporte': this.Item.codReporte,
                    'vigencia': this.Item.vigencia,
                    'niif': this.Item.niif,
                    'niif_nuevo': niifNuevo,
                }

                PlanConsolidacion.reclasificaNiif(form)
                    .then((res) => {
                        this.$toast.success(res.data.message)
                        this.clicked()
                        this.reload()
                    })
                    .catch((err) => {
                        console.log(err)
                        this.$toast.error(err.response?.data?.message || "Error al reclasificar NIIF")
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
                return
            }

            const descripcion = this.descripcionLocal || this.Item.descripcion
            if (!descripcion || descripcion == "") {
                this.$toast.error("Diligenciar el campo Descripción")
                return
            }

            this.isLoading = true
            let form = {
                'idNiif': this.Item.id,
                'descripcion': descripcion,
                'primer_nivel': this.selectedPrimerNivel || null,
                'segundo_nivel': this.selectedSegundoNivel || null
            }

            PlanConsolidacion.updatePlanconsolidacion(form)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.clicked()
                    this.reload()
                })
                .catch((err) => {
                    console.log(err)
                    this.$toast.error(err.response?.data?.message || "Error al actualizar NIIF")
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        reclasificarNiif() {
            this.showReclasifica = true
            this.niifNuevoLocal = this.Item.niif
            this.onChange()
        }
    }
}
</script>

<style src="../main.css"></style>